import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-26e2c2bf"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Tenant Details", -1))
const _hoisted_2 = { class: "input-results-address-container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "This will be used for billing.", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "This will be used for billing.", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "asteriskVisible" }, "Phone or Mobile Number", -1))
const _hoisted_6 = { class: "tenant-details-fields-container" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Priority Services", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Electricity Suppliers maintain a 'Priority", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Services Register' for customers who are", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "critically dependent on electrical equipment", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "in their homes. Please indicate if this applies", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "at the property.", -1))

import AcquaintTextbox from "@/components/ui/inputs/acquaint-textbox.vue";
import SelectOption from "@/components/ui/inputs/select-option.vue";
import lookupSingleSelect from "@/components/ui/lookup/lookup-single-select.vue";
import SwitchContactLookup from "@/components/ui/lookup/switch-contact-lookup.vue";
import scrollView from "@/components/ui/scroll-view.vue";
import { ContactFindTypeRestriction } from "@/enums/contacts/ContactFindTypeRestriction";
import { FieldSize } from "@/enums/system/FieldSize";
import { PersonalInfo } from "@/types/switches/PersonalInfo";
import { mapAcquaintContactToPersonalInfo } from "@/utils/utility-switching/SwitchContactMapper";
import { LookupTableSource } from "acquaint-api/constants/LookupTableSource";
import { Contacts } from "acquaint-api/models/Contacts";
import { ContactsValidation } from "acquaint-api/validation/ContactsValidation";
import { PropType, computed, inject, ref } from "vue";
import FieldValidationFreeDateBox from "../../ui/inputs/field-validation-free-date-box.vue";
import { VueTelInput } from "vue-tel-input";
import { AcquaintApiClient } from "@/services/AcquaintApiClient";
import { ContactPropertyRequirements } from "acquaint-api/models/ContactPropertyRequirements";
import { TextboxValueChangeEvent } from "@/enums/ui/inputs/TextboxValueChangeEvent";


export default /*#__PURE__*/_defineComponent({
  __name: 'tenant-details-page',
  props: {
  /**
   * The personal information of the tenant.
   * @type {PersonalInfo}
   */
  personalInfo: {
    type: Object as PropType<PersonalInfo>,
    required: true,
  },

  /**
   * Indicates whether the telephone number provided is valid.
   * @type {boolean}
   * @required
   */
  telephoneNumberValid: {
    type: Boolean,
    required: true,
  },
},
  emits: [
  "update:personalInfo",
  "update:telephoneNumberValid",
],
  setup(__props, { emit }) {

const props = __props;





const tenantPersonalInfo = computed({
  get: () => props.personalInfo,
  set: (value: PersonalInfo) => emit("update:personalInfo", value),
});

const screenWidth = ref(screen.width);

const apiClient = inject("AcquaintApiClient") as AcquaintApiClient;

const onContactSelected = async (e: Contacts) => {
  mapAcquaintContactToPersonalInfo(e, tenantPersonalInfo.value);
  tenantPersonalInfo.value.priorityService =
    await selectedContactRequiresCriticalCare(e.id);
};

const tenantMaxBirthDate = new Date(
  new Date().setFullYear(new Date().getFullYear() - 18),
);

const onCriticalCareSelected = (selectedOption: number) =>
  (tenantPersonalInfo.value.priorityService = selectedOption === 1);

/** Checks whether the passed contact requires critical care
 * @param contactId - Id of the Contact to check for critical care
 */
const selectedContactRequiresCriticalCare = async (contactId: number) => {
  // Contact's in Acquaint must have an id greater than 0
  if (contactId <= 0) {
    return false;
  }

  try {
    const requirements = await apiClient.httpGet<ContactPropertyRequirements>(
      `database/contactpropertyrequirements/${contactId}`,
    );
    return requirements?.criticalCare === 1;
  } catch {
    return false;
  }
};

const criticalCareToggleValue = computed(() =>
  tenantPersonalInfo.value.priorityService ? 1 : 2,
);

const telehpneInputOptions = {
  required: true,
};

const telephoneNumberValid = computed({
  get: () =>
    props.telephoneNumberValid == undefined ||
    props.telephoneNumberValid == false
      ? false
      : true,
  set: (value: Boolean) =>
    emit(
      "update:telephoneNumberValid",
      value == undefined || value == false ? false : true,
    ),
});

const phoneNumberValidated = (e: any) => {
  telephoneNumberValid.value = e.valid;
};

const preferredTelehoneNumbers = ["IE", "GB", "FR", "DE", "ES", "PL"];

const showTenantLookup = ref(false);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(scrollView, null, {
    default: _withCtx(() => [
      _createElementVNode("section", null, [
        _hoisted_1,
        _createElementVNode("div", {
          class: _normalizeClass(["tenant-details-container", { smallScreen: screenWidth.value < 875 }])
        }, [
          _createElementVNode("section", _hoisted_2, [
            (showTenantLookup.value)
              ? (_openBlock(), _createBlock(SwitchContactLookup, {
                  key: 0,
                  "find-type-restriction": _unref(ContactFindTypeRestriction).Tenants,
                  label: "Look up Tenant",
                  onContactSelected: onContactSelected,
                  toolTipTarget: "#tenantSearch",
                  toolTipId: "tenantSearch"
                }, {
                  "tooltip-content": _withCtx(() => [
                    _createTextVNode("Search for an existing contact to pre-fill the information below.")
                  ]),
                  _: 1
                }, 8, ["find-type-restriction"]))
              : _createCommentVNode("", true),
            _createVNode(lookupSingleSelect, {
              modelValue: tenantPersonalInfo.value.title,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((tenantPersonalInfo.value.title) = $event)),
              "lookup-source": _unref(LookupTableSource).Titles,
              label: "Title",
              requiredInput: false,
              validationGroup: "tenant",
              "allow-zero-value": true
            }, null, 8, ["modelValue", "lookup-source"]),
            _createVNode(AcquaintTextbox, {
              fieldValidation: _unref(ContactsValidation).FirstNames,
              modelValue: tenantPersonalInfo.value.firstName,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((tenantPersonalInfo.value.firstName) = $event)),
              label: "First Name",
              requiredInput: true,
              validationGroup: "tenant",
              useToolTip: true,
              toolTipId: "firstName",
              toolTipTarget: "#firstName",
              "value-change-event": _unref(TextboxValueChangeEvent).KeyUp
            }, {
              "tooltip-content": _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }, 8, ["fieldValidation", "modelValue", "value-change-event"]),
            _createVNode(AcquaintTextbox, {
              fieldValidation: _unref(ContactsValidation).LastName,
              modelValue: tenantPersonalInfo.value.lastName,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((tenantPersonalInfo.value.lastName) = $event)),
              label: "Last Name",
              requiredInput: true,
              validationGroup: "tenant",
              useToolTip: true,
              toolTipId: "secondName",
              toolTipTarget: "#secondName",
              "value-change-event": _unref(TextboxValueChangeEvent).KeyUp
            }, {
              "tooltip-content": _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }, 8, ["fieldValidation", "modelValue", "value-change-event"]),
            _hoisted_5,
            _createVNode(_unref(VueTelInput), {
              defaultCountry: 353,
              inputOptions: telehpneInputOptions,
              modelValue: tenantPersonalInfo.value.number,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((tenantPersonalInfo.value.number) = $event)),
              mode: "international",
              "valid-characters-only": true,
              onValidate: phoneNumberValidated,
              preferredCountries: preferredTelehoneNumbers
            }, null, 8, ["modelValue"]),
            _createVNode(AcquaintTextbox, {
              fieldValidation: _unref(ContactsValidation).Email,
              modelValue: tenantPersonalInfo.value.email,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((tenantPersonalInfo.value.email) = $event)),
              label: "Email",
              requiredInput: true,
              isEmail: false,
              validationGroup: "tenant",
              "value-change-event": _unref(TextboxValueChangeEvent).KeyUp
            }, null, 8, ["fieldValidation", "modelValue", "value-change-event"]),
            _createVNode(FieldValidationFreeDateBox, {
              label: "Date of Birth",
              fieldValidation: _unref(ContactsValidation).BirthDate,
              modelValue: tenantPersonalInfo.value.birthDate,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((tenantPersonalInfo.value.birthDate) = $event)),
              width: _unref(FieldSize).Small,
              required: true,
              maxDate: _unref(tenantMaxBirthDate),
              validationGroup: "tenant"
            }, null, 8, ["fieldValidation", "modelValue", "width", "maxDate"])
          ]),
          _createElementVNode("section", _hoisted_6, [
            _createElementVNode("div", null, [
              _createVNode(FieldValidationFreeDateBox, {
                modelValue: tenantPersonalInfo.value.tenancyStartDate,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((tenantPersonalInfo.value.tenancyStartDate) = $event)),
                label: "Tenancy Start Date",
                width: _unref(FieldSize).Small,
                required: true,
                validationGroup: "tenant"
              }, null, 8, ["modelValue", "width"])
            ]),
            _hoisted_7,
            _createVNode(SelectOption, {
              useToolTip: true,
              toolTipId: "priorityServices",
              toolTipTarget: "#priorityServices",
              title: "Priority Services (Critical Care)",
              selectBoxOneText: "Yes",
              selectBoxTwoText: "No",
              value: criticalCareToggleValue.value,
              onButtonSelected: onCriticalCareSelected
            }, {
              "tooltip-content": _withCtx(() => [
                _hoisted_8,
                _hoisted_9,
                _hoisted_10,
                _hoisted_11,
                _hoisted_12,
                _hoisted_13,
                _hoisted_14,
                _hoisted_15,
                _hoisted_16,
                _hoisted_17,
                _hoisted_18
              ]),
              _: 1
            }, 8, ["value"])
          ])
        ], 2)
      ])
    ]),
    _: 1
  }))
}
}

})